export default __webpack_public_path__ + "static/media/EAST3020.34I-36181_-21229_0.8ea05800.jpg";